import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import store from 'src/services/redux/app/Store';
import { ICatalogSearch } from '../../../../interfaces';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

interface IState {
  data: ICatalogSearch[];
  variant: any;
  loading: boolean;
  isShow: boolean;
  done: boolean;
  added: boolean;
  showError: boolean;
  error: any;
}

const initialState: IState = {
  data: [],
  variant: [],
  loading: false,
  done: false,
  error: null,
  showError: false,
  isShow: false,
  added: false,
};

export const catalogSearch = createAsyncThunk('catalog/list', async (data: any) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/${userId}/product/search?${data}`);
  return res.data;
});

export const catalogShow = createAsyncThunk('catalog/show', async ({ productId, params }: { productId: string; params?: { barcode?: string } }) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/${userId}/product/${productId}/show`, { params });
  return res.data;
});
export const catalogVariantList = createAsyncThunk('catalog/variant/list', async (productId: string) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/${userId}/product/${productId}/related/list`);
  return res.data;
});
export const catalogPriceAdd = createAsyncThunk('catalog/price/add', async (data: any, { rejectWithValue }) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  try {
    const res = await axios.post(`${VENDOR_MC_URL}/vendor/${userId}/inventory/add`, data);
    return res.data;
  } catch (err: any) {
    return rejectWithValue(err.response);
  }
});
const catalogSearchSlice = createSlice({
  name: 'catalogSearch',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
    setErrorMessage: (state, action) => {
      state.showError = true;
      state.error = action.payload;
    },
    setAdded: (state, action) => {
      state.added = action.payload;
    },
    setClearSearch: (state) => {
      state.data = [];
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(catalogSearch.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(catalogSearch.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.done = true;
    });
    builder.addCase(catalogSearch.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri eklenemedi.';
    });
    //
    builder.addCase(catalogShow.pending, (state, action) => {
      state.isShow = true;
    });
    builder.addCase(catalogShow.fulfilled, (state, action) => {
      state.isShow = false;
      state.data = action.payload;
      state.done = true;
    });
    builder.addCase(catalogShow.rejected, (state, action) => {
      state.isShow = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenmedi.';
    });
    //
    builder.addCase(catalogPriceAdd.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(catalogPriceAdd.fulfilled, (state, action) => {
      state.loading = false;
      state.done = true;
      state.added = true;
      // window.location.href="/products/my-products"
    });
    builder.addCase(catalogPriceAdd.rejected, (state, action: any) => {
      state.added = false;
      state.loading = false;
      state.showError = true;
      state.error = action.payload.data.message ? action.payload.data.message : action.payload.data.violations.map((message: any) => message.title).join(`\n`);
    });
    //
    builder.addCase(catalogVariantList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(catalogVariantList.fulfilled, (state, action) => {
      state.loading = false;
      state.variant = action.payload;
      state.done = true;
    });
    builder.addCase(catalogVariantList.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Ürün variantları listelenemedi.';
    });
  },
});
export const { setError, setErrorMessage, setAdded, setClearSearch } = catalogSearchSlice.actions;
export default catalogSearchSlice.reducer;
